import { Entity } from '../entity';

/**
 * Who put a tag on a job or stage (WBS-13087). Absent means a person did.
 *
 * Only the item tag recompute sets it, and it only ever removes a tag that carries it, so a tag a
 * person chose is never taken off by the product.
 */
export enum LabelAddedBy {
    /** Brought by a catalogue item's job tags; it goes when no item on the stage still brings it. */
    Item = 'item',
}

/** A tag in `Job.labels` or `WorkOrder.labels`. */
export interface JobLabel extends Entity {
    addedBy?: LabelAddedBy;
}
